// F9 (Pat, 2026-09-28): the Foundations /admin console is retired. Platform's Oversight and
// Provisioning consoles cover everything it did (companies, coordinators, sessions, delivery
// history, audit, suspend, test accounts) and more, across both products. The route stays so old
// bookmarks land somewhere useful instead of a blank page.

import { platformOversightUrl } from '../utils/platformUrl';

export default function AdminMoved({ hostname = typeof window !== 'undefined' ? window.location.hostname : '' }) {
  const href = platformOversightUrl(hostname);
  return (
    <main className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
      <div className="max-w-lg rounded-lg border border-slate-700 bg-slate-900 p-8">
        <h1 className="text-xl font-semibold mb-3">Admin has moved to Platform</h1>
        <p className="text-slate-300 mb-6">
          Companies, coordinators, sessions, invitations and their delivery history, suspensions and
          test accounts are now managed in Platform&apos;s Oversight console, for Foundations and PRISM
          together.
        </p>
        <a
          href={href}
          className="inline-block rounded bg-sky-600 px-4 py-2 font-medium text-white hover:bg-sky-500"
        >
          Open Platform Oversight →
        </a>
      </div>
    </main>
  );
}
